module.exports = __webpack_public_path__ + "img/icon-26.b9d7f018.png";